import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
const MysteryCarLogosComponent = ({ collection, renters }) => {
    const { t } = useTranslation();
    const [rentersArray, setRentersArray] = useState([]);
    useEffect(() => {
        setRentersArray((prevRentersArray) => {
            // Map renters to an array of names and convert to lowercase
            const newRentersArray = renters.map((renter) => renter.renterName.toLowerCase());
            // Use a Set to keep track of unique names
            const uniqueNamesSet = new Set([...prevRentersArray, ...newRentersArray]);
            // Convert the Set back to an array
            const uniqueNamesArray = Array.from(uniqueNamesSet);
            return uniqueNamesArray;
        });
    }, [renters]);
    return (_jsxs("div", { className: "brandstar-multiples", children: [_jsx("div", { className: "brandstar-multiples__text", children: t("delivery_by_results") }), _jsx("div", { className: "brandstar-multiples__logos", children: rentersArray.map((renter, index) => {
                    var _a, _b;
                    return (_jsx("div", { className: "img_logo_cnt", children: _jsx("img", { alt: "brand", className: "logo-brandstar-multiples", id: "img_logo_multiple_results" + index, src: (_b = (_a = collection.find((collection) => collection.title.toLowerCase() === renter)) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.src }) }, index));
                }) })] }));
};
export default MysteryCarLogosComponent;
